"use strict";var t=require("../stringRepeat.cjs");exports.stringPad=function(e,r,n){return void 0===n&&(n=" "),r=Math.floor(r),e.length>=r?"":((r-=e.length)>n.length&&(n+=t.stringRepeat(n,r/n.length)),n.slice(0,r))};
//# sourceMappingURL=stringPad.cjs.map
